export { default } from "./SummaryItemGraphic";
